import { gql } from '@apollo/client'

export const TEMPLATES_QUERY = gql`
  query Templates($providerCode: String!) {
    templates(providerCode: $providerCode) {
      Id
      Title
    }
  }
`
export const TEMPLATE_QUERY = gql`
  query Template($providerCode: String!, $templateID: String!) {
    template(providerCode: $providerCode, templateID: $templateID) {
      Title
      Templates {
        CurrencyDiscounts {
          DiscountPercent
          Currency
        }
        From
        Restrictions {
          CTA
          CTD
          MaxStay
          Status
          MinStay
        }
        To
        Weekdays {
          Friday
          Monday
          Saturday
          Sunday
          Thursday
          Tuesday
          Wednesday
        }
      }
    }
  }
`

export const MODIFY_TEMPLATE_MUTATION = gql`
  mutation ModifyTemplate(
    $input: TemplateDataInput!
    $providerCode: String!
    $templateID: String!
  ) {
    modifyTemplate(
      input: $input
      providerCode: $providerCode
      templateID: $templateID
    ) {
      message
    }
  }
`

export const GENERATE_TEMPLATE_MUTATION = gql`
  mutation GenerateTemplate(
    $input: TemplateDataInput!
    $providerCode: String!
  ) {
    generateTemplate(input: $input, providerCode: $providerCode) {
      message
    }
  }
`
